import { KeyValue } from 'ngrx-forms';
import { map, withLatestFrom } from 'rxjs';

import { ActivatedRoute } from '@angular/router';
import {
  BreadcrumbItem,
  LazyEntityFacadeInterface,
  RouterFacadeInterface,
} from '@ideapa/app-common';
import { BaseDto } from '@ideapa/common-dto';

import { BaseContainer } from './base.container';

export abstract class BaseRootContainer<
  T extends BaseDto,
  K extends KeyValue
> extends BaseContainer {
  breadcrumb$ = this.facade.getBreadcrumb$;

  constructor(
    private facade: LazyEntityFacadeInterface<T, K>,
    private router: RouterFacadeInterface,
    private activatedRoute: ActivatedRoute
  ) {
    super();
  }

  showBreadcrumb() {
    return this.facade.entityId$.pipe(
      withLatestFrom(
        this.router.isAddMode$,
        this.router.isEditMode$,
        this.router.isFindMode$,
        this.router.isViewOnlyMode$,
        this.router.isModalListMode$
      ),
      map(
        ([
          entityId,
          isAddMode,
          isEditMode,
          isFindMode,
          isViewOnlyMode,
          isModalListMode,
        ]) => {
          if (entityId == null) {
            return (
              !isAddMode &&
              !isEditMode &&
              !isFindMode &&
              !isViewOnlyMode &&
              !isModalListMode
            );
          } else {
            return !isAddMode && !isEditMode && !isFindMode && !isViewOnlyMode;
          }
        }
      )
    );
  }

  navigate(item: BreadcrumbItem) {
    item.beforeNavigate?.();

    this.router.navigateRelative([item.link], undefined, this.activatedRoute);
  }
}
